export function getStorageUrl(): string {
  return `${process.env.REACT_APP_STORAGE_URL}/${process.env.REACT_APP_STORAGE_BUCKET}`;
}
